import { Injectable } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material";
import { AttributeCode, AttributeValue, UserAttributeInterface } from "../../model/finzy-flex/user-attribute.model";
import { Preferences } from "../../model/preferences.model";
import { UserAttributeService } from "../../service/finzy-flex/user/user-attribute.service";
import { ConfirmationPopupWithSvgComponent } from "../../views/investors/finzy-flex/confirmation-popup-with-svg/confirmation-popup-with-svg.component";

@Injectable()
export class ShowTurnOffSwiftPopupUtil {

    private userAttributeService: UserAttributeService;
    private readonly matDialog: MatDialog;

    constructor(matDialog: MatDialog, userAttributeService : UserAttributeService) {
        this.matDialog = matDialog;
        this.userAttributeService = userAttributeService;
    }

    public async showFinzySwiftPopup(preferences: Preferences, loader: any, userId: string) {
        const res = await this.showSwiftPopupWarning({
			data: {
				title: 'Switch Off Swift',
				subTitle: `Switch off <strong class="black">Swift</strong> to start <strong class="black">finzyPro</strong> investment`,
				message: `To invest in  <strong class="black">finzyPro</strong> or enable <strong class="black">finzyBolt</strong>, your existing auto investment option (<strong class="black">Swift</strong>) has to be switched off.`,
                positiveButtonText: 'Switch Off',
				negativeButtonText: 'Later',
				image: '../../../../../assets/gif/finzy-flex/switchOffForBolt.svg'
			},
			width: '50%',
			minWidth: '320px',
			panelClass: "confirm-dialog-with-svg-responsive"
		});
		if (res) {
            loader.spin = true;
			const allInvestmentPreferences = preferences.investmentAttrs;
            const updatedPreferences = allInvestmentPreferences.filter(i => i.attributeCode != AttributeCode.AUTO_INVESTMENT_FROM_WALLET_TYPE && i.attributeCode != AttributeCode.INVESTMENT_FUND_ALLOCATION);
            var response: UserAttributeInterface = await this.userAttributeService.putUserAttribute({ investmentPreferences: updatedPreferences, automaticInvestmentsFromWallet: preferences.automaticInvestmentsFromWallet, isNCashModified: false, isSwiftModified: true }, userId);

            return response;
        }
        else {
            return {
                status: 2,
                count: 0,
                data: [],
                total: 0
            };
        }
    }

    private showSwiftPopupWarning(data: MatDialogConfig): Promise<boolean> {
        return this.matDialog.open(ConfirmationPopupWithSvgComponent, data).afterClosed().toPromise();
    }

    public isSwiftEnabled(preferences: Preferences): boolean {
        return preferences?.investmentAttrs.find(preference => preference.attributeCode === AttributeCode.AUTO_INVESTMENT_FROM_WALLET_TYPE
            &&  preference.attributeValue === AttributeValue.SWIFT ) ? true: false;
    }
}
